/** @jsx jsx */
import React from "react";
import { jsx, Flex, Paragraph } from "theme-ui";
import Icon from "../Icon";

const FormErrorMessage = ({ error }) => error ? (
    <Flex sx={{ mt: "5px", alignItems: "center", color: "red" }}>
      <Icon icon="error" />
      <Paragraph variant="p2" sx={{ color: "red", ml: "5px" }}>
        {error.message}
      </Paragraph>
    </Flex>
  ) : (
    <Paragraph
      variant="p2"
      sx={{
        mt: "5px",
        display: "none",
        visibility: "hidden",
        color: "red",
      }}
    >
      Error message placeholder
    </Paragraph>
);

export default FormErrorMessage;
